<template>
  <div class="cashcreation">
    <div class="header-text"
         :style="{ width: ElementHeight }">
      <h1 class="header-title">礼品主数据定义-修改</h1>
      <div class="buttom-div">
        <el-button class="push-button"
                   @click="Createintegral">保存</el-button>
        <el-button class="push-button"
                   icon="iconfont icon-fanhui"
                   @click="backHistory">返回</el-button>
      </div>
    </div>
    <div class="header-text1"></div>
    <div>
      <el-card shadow="never"
               class="card-center"
               style="margin-top: 10px">
        <!-- 表单 -->
        <div style="width: 100%; height: 50%; margin: 0 auto">
          <el-form size="small"
                   :label-position="labelPosition"
                   label-width="100px">
            <el-row :gutter="200">
              <el-col :span="12">
                <el-form-item label="礼品编号">
                  <el-input v-model="tableList.giftNo"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="礼品名称">
                  <el-input v-model="tableList.giftName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="礼品类型">
                  <el-select v-model="tableList.giftKind"
                             style="width: 100%"
                             :disabled="tableList.state !== 1">
                    <el-option v-for="item in options"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单位">
                  <el-input style="width: 100%"
                            v-model="tableList.giftUnit"
                            :disabled="tableList.state !== 1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注">
                  <el-input style="width: 62%"
                            v-model="tableList.remark"
                            type="textarea"
                            :disabled="tableList.state !== 1"></el-input>
                  <span style="margin-left:15px;color:blue">注：填写用途、有效期等</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="200">
              <el-col :span="12"
                      v-if="tableList.state === 1">
                <el-form-item label="颜色">
                  <div class="flex-between">
                    <el-input v-model="insertaddList.colorName"></el-input>
                    <el-button style="margin-left: 10px"
                               @click="Colorbtn">新增</el-button>
                  </div>
                </el-form-item>
                <div style="margin-top: 10px">
                  <el-table size="mini"
                            :header-cell-style="{
                          'text-align': 'center',
                        }"
                            :cell-style="{ 'text-align': 'center' }"
                            :data="newApp"
                            border>
                    <el-table-column type="index"
                                     width="40">
                    </el-table-column>
                    <el-table-column prop="attrValue"
                                     label="颜色">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button type="text"
                                   style="width: 60px"
                                   @click.native.prevent="
                                deletebtnSer(scope.$index, newApp)
                              ">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
              <el-col :span="12"
                      v-if="tableList.state === 1">
                <el-form-item label="尺码">
                  <div class="flex-between">
                    <el-input v-model="insertaddList.sizeName"></el-input>
                    <el-button style="margin-left: 10px"
                               @click="SizeNamebtn">新增</el-button>
                  </div>
                </el-form-item>
                <div style="margin-top: 10px">
                  <el-table size="mini"
                            :header-cell-style="{
                          'text-align': 'center',
                        }"
                            :cell-style="{ 'text-align': 'center' }"
                            :data="newArr"
                            border>
                    <el-table-column type="index"
                                     width="40">
                    </el-table-column>
                    <el-table-column prop="attrValue"
                                     label="尺码">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button type="text"
                                   @click.native.prevent="
                                deletesizebtn(scope.$index, newArr)
                              "
                                   style="width: 60px">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="200">
              <el-col :span="12">
                <el-form-item>
                  <el-button style="
                          width: 100%;
                          background-color: #b6b388;
                          color: #fff;
                          margin-left: 19vw;
                          margin-top:10px
                        "
                             @click="Createbtn"
                             v-if="tableList.state === 1">
                    生成
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="SKU">
                  <el-table size="mini"
                            :row-class-name="tableRowClassName"
                            :header-cell-style="{
                          background: '#FCFBF2',
                          'text-align': 'center',
                          color: '#6C6839',
                        }"
                            :cell-style="{ 'text-align': 'center' }"
                            :data="todoLister"
                            border
                            infinite-scroll-disabled="true">
                    <el-table-column type="index"
                                     width="40">
                    </el-table-column>
                    <el-table-column prop="sku"
                                     label="礼品编号">
                    </el-table-column>
                    <el-table-column prop="colorName"
                                     label="颜色">
                    </el-table-column>
                    <el-table-column prop="sizeName"
                                     label="尺码">
                    </el-table-column>
                    <el-table-column prop="productSKU"
                                     label="POS-SKU">
                      <template slot-scope="scope">
                        <el-autocomplete :fetch-suggestions="querySearchAsync"
                                         :trigger-on-focus="false"
                                         v-model="scope.row.productSKU"
                                         @select="handleSelect"
                                         style="width: 100%"
                                         placeholder="请输入SKU编码">
                        </el-autocomplete>
                      </template>
                    </el-table-column>
                    <el-table-column prop="accessoriesSize"
                                     label="配饰规格">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.accessoriesSize"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item>

              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { reserveGIfSeetupdate, reserveGIfSeetSku, reserveGIfSeetApi } from "@/api/Integralquery";
export default {
  name: "centre",
  data () {
    return {
      screenWidth: "",
      ElementHeight: "0px",
      lookVisible: false,
      labelPosition: "right",
      //新增请求参数
      insertaddList: {
        giftName: "", //礼品名称
        giftUnit: "", //单位
        remark: "", //备注
        giftKind: "", //礼品类型
        //---------尺码颜色
        colorName: "", //颜色名称
        sizeName: "", //尺码名称
      },
      //表格数据
      todoLister: [],
      //颜色存放
      newApp: [],
      //尺码存放
      newArr: [],
      tableData: [],
      //商品sku存放
      restaurants: [],
      state: "",
      timeout: null,
      cuar: {
        pageNo: "1",
        pageSize: "100",
      },
      //尺寸赋值传参
      chicun: [],
      //颜色赋值传参
      // yarnser: [],
      //sku赋值传参
      // Skulist: [],
      //配饰传参
      // commitlist: [],
      DescartesList: [],
      tableList: [],
      // handleRadioValue: [],
      options: [
        {
          value: 0,
          label: "成衣",
        },
        {
          value: 1,
          label: "革履",
        },
        {
          value: 2,
          label: "配饰",
        },
        {
          value: 3,
          label: "非公司商品",
        },
      ],
    };
  },
  watch: {
    //窗口宽度变化
    screenWidth () {
      this.ElementHeight =
        document.querySelector(".cashcreation").offsetWidth + "px";
    },
  },
  mounted () {
    reserveGIfSeetSku(this.cuar).then((res) => {
      if (res.message == "success") {
        res.data.list.forEach((item) => {
          this.restaurants.push({
            value: item.sku,
          });
        });
      }
    });
    this.getELmentHeight()
  },
  created () {

    this.Colorview()
  },
  methods: {
    getELmentHeight () {
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName ({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    //颜色新增功能
    Colorbtn () {
      if (this.insertaddList.colorName == "") {
        return this.$message.warning("请输入内容！");
      }
      let newColorname = {
        attrValue: this.insertaddList.colorName,
      };
      this.newApp.push(newColorname);
      this.insertaddList.colorName = "";
    },
    //删除功能
    deletebtnSer (index, rowes) {
      rowes.splice(index, 1);
    },
    //尺寸新增功能
    SizeNamebtn () {
      if (this.insertaddList.sizeName == "") {
        return this.$message.warning("请输入内容！");
      }
      let newSizename = {
        attrValue: this.insertaddList.sizeName,
      };
      this.newArr.push(newSizename);
      this.insertaddList.sizeName = "";
    },
    //尺寸删除
    deletesizebtn (index, rowes) {
      rowes.splice(index, 1);
    },
    //生成功能
    Createbtn () {
      let cuaring = [];
      this.DescartesList = [];
      this.newApp.forEach((itemapp) => {
        this.DescartesList.push(itemapp.attrValue)
        this.newArr.forEach((itemarr) => {
          this.DescartesList.push(itemapp.attrValue + "," + itemarr.attrValue);
        });
      });
      for (let i = 0; i < this.DescartesList.length; i++) {
        this.forMlist = this.DescartesList[i].split(",");
        cuaring.push({
          colorName: this.forMlist[0],
          sizeName: this.forMlist[1],
          productSKU: "",
          accessoriesSize: "",
        });
      }
      if (this.newArr.length > 0) {
        cuaring.forEach((item, i) => {
          if (item.sizeName === undefined) {
            cuaring.splice(i, 1)
          }
        })
      }
      this.todoLister.forEach((item) => {
        cuaring.forEach((myitem) => {
          if (
            item.colorName == myitem.colorName &&
            item.sizeName == myitem.sizeName
          ) {
            myitem.productSKU = item.productSKU;
          }
        });
      });
      this.todoLister = cuaring;
    },
    //禁用input框 type='number' 时绑定值会随着鼠标滚动上下滑动增减值
    stopScroll (evt) {
      evt = evt || window.event;
      if (evt.preventDefault) {
        // Firefox
        evt.preventDefault();
        evt.stopPropagation();
      } else {
        // IE
        evt.cancelBubble = true;
        evt.returnValue = false;
      }
      return false;
    },
    openDetails (row) {
      console.log(row);
    },
    deletebtar (index, rows) {
      console.log(index, rows);
    },
    //模糊查询
    querySearchAsync (queryString, cb) {
      var shopList = this.restaurants;
      // console.log(shopList);
      var results = queryString
        ? shopList.filter(this.createStateFilter(queryString))
        : shopList;
      cb(results);
    },
    handleSelect (item) {
      console.log(item);
    },
    createStateFilter (queryString) {
      return (shopLis) => {
        return (
          shopLis.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    //修改保存
    Createintegral () {
      let coolink = {
        giftName: this.tableList.giftName, //礼品名称
        remark: this.tableList.remark, //备注
        giftUnit: this.tableList.giftUnit, //单位
        giftID: this.tableList.giftID,
        giftKind: this.tableList.giftKind
      };

      let arr = [];
      this.todoLister.forEach((item, i) => {
        arr.push({});
        arr[i] = {
          accessoriesSize: item.accessoriesSize,
          colorName: item.colorName,
          giftSKUID: item.giftSKUID,
          productSKU: item.productSKU,
          sizeName: item.sizeName,
        };
      });
      reserveGIfSeetupdate(coolink, arr).then((res) => {
        if (res.message == "success") {
          this.$message.success("修改成功")
          this.newApp = [];
          this.newArr = [];
          this.todoLister = [];
          this.$router.push({
            path: '/MasterData'
          })
        }
      });
    },
    clearbtn () {
      this.$router.push({ path: "/MasterData" });
    },
    //点击修改时显示颜色尺码
    async Colorview () {
      await reserveGIfSeetApi({ giftID: this.$route.query.x }).then(
        (res) => {
          if (res.message == "success") {
            this.todoLister = res.tGiftskuList;
            this.tableList = res.data
            console.log('----', this.tableList);
            res.tGiftattrList.forEach((item) => {
              if (item.attrKind == 1) {
                this.newApp.push(item);
              }
              if (item.attrKind == 2) {
                this.newArr.push(item);
              }
            });
          }
        }
      );
    },
    backHistory () {
      this.$router.go(-1)
    }
  },
};
</script>
<style lang="scss" scoped>
#giftdatacreation {
  height: 100%;
}
.header-text {
  position: fixed;
  z-index: 88;
  margin-top: -1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background-color: #f3f5f7;
  height: 4.5rem;
  color: #76734f;
  padding-bottom: 5px;
}
.card-pagination {
  height: 50px;
}

// 按钮边框去掉，文字颜色和加粗
// /deep/button {
//   border-color: #e6e0af;
//   border-radius: 7px;
//   color: #a19b59;
// }

// input框的圆角取消
/deep/input {
  border-radius: 0 !important;
}

::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
}
//隐藏
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
.el-table {
  /deep/.el-input__inner {
    border: 0 !important;
    text-align: center;
  }
}
.cashcreation {
  margin-bottom: 100px;
}
.header-text1 {
  height: 3.5rem;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: flex-end;
  width: 250px;
  height: 50px;
  align-content: center;
}
.push-button {
  width: 100px;
  color: #a19b59;
}
.header-title {
  min-width: 250px;
  line-height: 50px;
  height: 50px;
}
</style>
